module.exports = {"menu":{"home":"집","starship":"우주선","profile":"프로필","ranking":"순위","settings":"설정"},"landing":{"spaceship-travel":"우주선으로 여행"},"profile":{"change-language":"언어 변경","change-language-en":"Change language to English","change-language-es":"Change language to Spanish","change-language-kr":"Change language to Korean"}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko.json
// module id = N2Z1
// module chunks = 0